export var diamondBackground = '$_3NrJQ';